import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex justify-space-between align-items-center" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Inquiry from '../../../api/v2/models/inquiry'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import UserInquiryDialog from '../organisms/UserInquiryDialog.vue'
import InquiryView from '../atoms_molecules/InquiryView.vue'
import { ROUTER_NAME } from '../../router'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryList',
  setup(__props) {

const router = useRouter()

// Template refs
const confirm = ref<InstanceType<typeof ConfirmDialog> | null>(null)

// Reactive state
const inquiries = ref<Inquiry[]>([])

// Breadcrumbs
const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: '問い合わせ一覧',
    disabled: false,
    exact: true,
    to: '/classroom/inquiries'
  }
]

// Methods
const getList = async () => {
  inquiries.value = await api.inquiry.index()
}

const toDetail = (inquiry: Inquiry) => {
  router.push({
    name: ROUTER_NAME.INQUIRY_DETAIL,
    params: {
      inquiryId: inquiry.id.toString()
    }
  })
}

const deleteInquiry = async (id: number) => {
  try {
    if (confirm.value && await (confirm.value as any).open('本当によろしいですか？')) {
      await api.inquiry.delete(id)
      getList()
    }
  } catch (e) {
    // Handle error silently
  }
}

// Lifecycle
onMounted(() => {
  headerState.setTitle('問い合わせ')
  footerState.setFooterDefault()
  getList()
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: '問い合わせ一覧' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        class: "p-3 bg-white"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-bold" }, " お問い合わせ一覧 ", -1 /* CACHED */)),
            _createVNode(UserInquiryDialog, { onInquirySubmited: getList })
          ]),
          _createVNode(_component_v_divider, { class: "mt-3" }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inquiries.value, (inquiry) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `${inquiry.id}-inquiry`
            }, [
              _createVNode(InquiryView, {
                inquiry: inquiry,
                onClick: ($event: any) => (toDetail(inquiry))
              }, {
                action: _withCtx(() => [
                  _createVNode(UserInquiryDialog, {
                    inquiry: inquiry,
                    onInquirySubmited: getList
                  }, null, 8 /* PROPS */, ["inquiry"]),
                  _createVNode(_component_v_btn, {
                    size: "small",
                    color: "red",
                    variant: "tonal",
                    class: "ms-2",
                    onClick: _withModifiers(()=> { deleteInquiry(inquiry.id) }, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-delete", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["inquiry", "onClick"]),
              _createVNode(_component_v_divider)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(ConfirmDialog, {
      ref_key: "confirm",
      ref: confirm
    }, null, 512 /* NEED_PATCH */)
  ]))
}
}

})